module.exports = __webpack_public_path__ + "static/media/learning-20.cd647d01.png";